import { API_REQUEST } from 'redux-api-request/dist/action_types'

const COUNTS_GET_REQUEST = 'COUNTS_GET_REQUEST';
const COUNTS_GET_SUCCESS = 'COUNTS_GET_SUCCESS';
const COUNTS_GET_FAILURE = 'COUNTS_GET_FAILURE';

export const get = () => ({
  type: API_REQUEST,
  method: 'GET',
  endpoint: '/api/counts',
  // body: { email, password },
  request: COUNTS_GET_REQUEST,
  success: COUNTS_GET_SUCCESS,
  failure: COUNTS_GET_FAILURE
})




// WEBPACK FOOTER //
// ./src/modules/counts/counts.actions.js